// @ts-nocheck 22505e21

const getCompClass =
  (compType) =>
  (dispatch, getState, { compFactoryService }) =>
    compFactoryService.getCompClass(compType);

export { getCompClass };
